import React from 'react';
import sbondLogo from '../../assets/img/sbond-logo.png'; // Import the SBOND logo
import hogLogo from '../../assets/img/hog-logo.webp'; // Import the SBOND logo
import ghogLogo from '../../assets/img/ghog-logo.webp'; // Import the SBOND logo
import bhogLogo from '../../assets/img/bhog-logo.webp'; // Import the SBOND logo
import osLogo from '../../assets/img/tokens/OS.png'; 
import anonLogo from '../../assets/img/tokens/ANON.png'; 
import swpxLogo from '../../assets/img/tokens/SWPX.png'; 
import stsLogo from '../../assets/img/tokens/STS.png'; 
import scusdLogo from '../../assets/img/tokens/SDCUSD.png'; 
import mclbLogo from '../../assets/img/tokens/mclb.webp'; 
import indiLogo from '../../assets/img/tokens/INDI.png'; 
import goglzLogo from '../../assets/img/tokens/goglz.webp'; 
import beetsLogo from '../../assets/img/tokens/beets.webp'; 
import godAi from '../../assets/img/god_ai.webp'; 


const logosBySymbol: { [title: string]: string } = {

  HOG: hogLogo,
  GHOG: ghogLogo,
  BHOG: bhogLogo,
  "HOG-OS": sbondLogo,
  "HOG-OS-LP": sbondLogo,
  OS: osLogo,
  god: godAi,
  ANON: anonLogo,
  SWPx: swpxLogo,
  stS: stsLogo,
  scUSD: scusdLogo,
  MCLB: mclbLogo,
  INDI: indiLogo,
  Beets: beetsLogo,
  GOGLZ: goglzLogo,
  
  
  
  
  S: sbondLogo,
  wS: sbondLogo,
  x33: sbondLogo,
  SHADOW: sbondLogo,
  DOLA: sbondLogo,
  USDz: sbondLogo,
  msETH: sbondLogo,
  MAI: sbondLogo,
  msUSD: sbondLogo,
  LRDS: sbondLogo,
  HBR: sbondLogo,
  USDbC: sbondLogo,
  VIRTUAL: sbondLogo,
  cbBTC: sbondLogo,
  OX: sbondLogo,
  RECORD: sbondLogo,
  RFL: sbondLogo,
  ION: sbondLogo,
  SAM: sbondLogo,
  BAVA: sbondLogo,
  BOTTO: sbondLogo,
  BET: sbondLogo,
  "USDC.e": sbondLogo,
  ICL: sbondLogo,
  fBOMB: sbondLogo,
  WELS: sbondLogo,
  KLIMA: sbondLogo,
  WELL: sbondLogo,
  PDT: sbondLogo,
  "OVN": sbondLogo,
  ["USD+"]: sbondLogo,
  TKN: sbondLogo,
  BCT: sbondLogo,
  wstETH: sbondLogo,
  TAROT: sbondLogo,
  WETH: sbondLogo,
  MET: sbondLogo,
  JARVIS: sbondLogo,
  OGN: sbondLogo,
  superOETHb: sbondLogo,
  'HOG-S-LP': sbondLogo,
  'GHOG-OS-LP': sbondLogo,

  TSHARE: sbondLogo,
  LQDR: sbondLogo,
  'CRE8R': sbondLogo,
  TOMB: sbondLogo,
  FTM: sbondLogo,
  BOO: sbondLogo,
  SHIBA: sbondLogo,
  ZOO: sbondLogo,
  fUSDT: sbondLogo,
  EAGLE: sbondLogo,
  BASED: sbondLogo,
  BTC: sbondLogo,
  FRAX: sbondLogo,
  TBOND: sbondLogo,
  "TOMB+": sbondLogo,
  'TOMB-S-LP': sbondLogo,
  'TSHARE-S-LP': sbondLogo,
  'LQDR-S-LP': sbondLogo,
  'CRE8R-S-LP': sbondLogo,
  'fUSDT-S-LP': sbondLogo,
  'USDC-S-LP': sbondLogo,
  'BTC-S-LP': sbondLogo,
  'S-S-LP': sbondLogo,
  'FRAX-S-LP': sbondLogo,
  'MAI-S-LP': sbondLogo,

  BOAT: sbondLogo,
  BOMB: sbondLogo,
  BIFI: sbondLogo,
  DEI: sbondLogo,
  DAI: sbondLogo,
  gOHM: sbondLogo,
  ATLAS: sbondLogo,
  DEUS: sbondLogo,
  'BOMB-S-LP': sbondLogo,
  'BIFI-S-LP': sbondLogo,
  'DEI-USDC-LP': sbondLogo,
  'gOHM-S-LP': sbondLogo,
  'ATLAS-S-LP': sbondLogo,
  'DEUS-S-LP': sbondLogo,

  'SPOOKYSWAP': sbondLogo,
  'SPIRITSWAP': sbondLogo,
};

type LogoProps = {
  symbol: string;
  size?: number;
};

const TokenSymbol: React.FC<LogoProps> = ({ symbol, size = 64 }) => {
  if (!logosBySymbol[symbol]) {
    throw new Error(`Invalid Token Logo symbol: ${symbol}`);
  }
  if (symbol === "WELS") {
    return <img style={{borderRadius: "1000px", background: "#fff"}} src={logosBySymbol[symbol]} alt={`${symbol} Logo`} width={size} height={size} />;
  }
  return <img style={{borderRadius: "1000px", background: "#000000"}} src={logosBySymbol[symbol]} alt={`${symbol} Logo`} width={size} height={size} />;
};

export default TokenSymbol;
